import { roomTimelineHandler } from './handlers/Room.timeline';
import { RoomSettingsHandler } from './handlers/RoomSettingsHandler';
import { membershipHandler } from './handlers/membership';
import { powerLevelsHandler } from './handlers/powerLevels';
import { receiptHandler } from './handlers/receipt';
import { roomHandler } from './handlers/room';
import { roomMemberHandler } from './handlers/roomMember';
import { roomNameHandler } from './handlers/roomName';
import { syncHandler } from './handlers/sync';
import { timelineHandler } from './handlers/timeline';
import { unreadHandler } from './handlers/unread';

let isInitialized = false;
export function initRoomHandlers() {
    if (isInitialized){
        throw new Error('Room handlers already initialized');
    }
    isInitialized = true;
    // 初始化所有事件处理器
    syncHandler.init();
    timelineHandler.init();
    membershipHandler.init();
    roomHandler.init();
    roomNameHandler.init();
    unreadHandler.init();
    receiptHandler.init();
    roomMemberHandler.init();
    roomTimelineHandler.init();
    RoomSettingsHandler.init();
    powerLevelsHandler.init();
}
